import React from "react";
import flowers from "../data/celeMaiVindute";
import FlowerSection from "../components/FlSectHomePage";

const CeleMaiVinduteHome = () => {
  return (
    <FlowerSection
      flowers={flowers}
      title="Selecția Gardenia"
      subtitle="Lasă florile să vorbească"
      // title="Cele mai vindute buchete"
      // subtitle="Indiferent dacă vrei să îți exprimi dragostea, recunoștința sau să oferi un gest elegant, avem buchetul perfect pentru tine."
      storageKey="CELE_MAI_VINDUTE_SCROLL_POSITION"
      id="cele-mai-vindute"
    />
  );
};

export default CeleMaiVinduteHome;
